const env = "production"; //'demo'

export const API_KEY = env === "demo" ? "AIzaSyBDsY25nJ4VZz0iiLLQpPRnjMRnIHkyqg4" : "AIzaSyCLnELKkhtI7078gcDyuIBth5PgUx6Ef4I";
export const CLIENT_ID = env === "demo" ? "demo" : "blog_betway_com";
export const TEMPLATE_ID = env === "demo" ? "257FxYRDvcbsBVxOKOY6s8" : "257FxYRDvcbsBVxOKOY6s8";

// Betway account URLs by country
export const BETWAY_ACCOUNT_URLS = {
	ZA: "https://new.betway.co.za/?btag=P87216-PR37784-CM109294-TS2078304&utm_source=BetwayScoresGames&utm_medium=Betway_Scores_Fantasy_Game&utm_campaign=Betway_Scores&utm_content=Fantasy_Football_Scores",
	GH: "https://www.betway.com.gh/?btag=P87216-PR38046-CM112327-TS2078310&utm_source=BetwayScoresGames&utm_medium=Betway_Scores_GH_Fantasy_Game&utm_campaign=Betway_Scores&utm_content=Fantasy_Football_Scores",
	// Rest of World (RoW) - default fallback
	ROW: "https://betway.com/en/sports?s=bw219941&a=DB4501775225688466&utm_source=219941&utm_medium=Affiliate&utm_campaign=DB4501775225688466",
};
